import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { UPLOAD_ATTACHMENT } from './queries';
import { Dropzone, MultiDropzone } from '../../elements/Dropzone';
import { TitleContainer, ContainerTitle } from '../../elements';
import { View } from 'react-native';
import { ButtonContainer } from './elements';
import { ButtonGroup, Button } from '../../elements/buttons';

const NewAttachment = (props) => {
  const {
    recordId,
    recordType,
    setShowModal,
    attachmentType,
    updateAttachments,
    setValue
  } = props;
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploaded, setUploaded] = useState([]);
  const [file, setFile] = useState();
  const [files, setFiles] = useState();
  const [uploadAttachment] = useMutation(UPLOAD_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        updateAttachments(
          attachmentType,
          'add',
          response.uploadAttachment.attachment
        )
      }
    }
  );

  let name = 'photos';
  if ('Document' === attachmentType) {
    name = 'documents';
  }

  const handleSubmit = () => {
    setFormSubmitting(true)
    if (file) {
      uploadAttachment(
        {variables: { recordType, recordId, file, name, primary: false }}
      )
    }
  }

  const handleFile = (file) => {
    setFile(file)
    if(attachmentType === 'Title Log') {
      setValue('upload', file);
    }
  }

  return (
    <View>
      <Dropzone
        accept={getAccepted()}
        description="Drag and drop files here, or click to choose files."
        handleFile={handleFile}
      />
      {attachmentType !== 'Title Log' && attachmentType !== 'Expense File' &&
        <ButtonContainer>
          <ButtonGroup>
            <Button
              label={`Upload ${attachmentType}`}
              onPress={() => handleSubmit()}
            />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )

  function getAccepted() {
    let accepted = ".jpeg, .jpg, .png, .heic";
    if(attachmentType === 'Document' || attachmentType === 'Expense File') {
      accepted = ".pdf, .xls, .xlsx, .doc, .docx";
    }else if(attachmentType === 'Title Log') {
      accepted = ".pdf, .jpeg, .jpg, .png, .heic";
    }

    return accepted;
  }
}

export default NewAttachment;

export const NewAttachments = (props) => {
  const {
    recordId,
    recordType,
    setShowModal,
    attachmentType,
    updateAttachments,
    setValue
  } = props;
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [uploaded, setUploaded] = useState([]);
  const [files, setFiles] = useState(props.existingFiles || []);
  const [uploadAttachment] = useMutation(UPLOAD_ATTACHMENT,
    {
      onCompleted(response) {
        setShowModal(false);
        updateAttachments(
          attachmentType,
          'add',
          response.uploadAttachment.attachment
        )
      }
    }
  );

  let name = 'photos';
  if ('Document' === attachmentType) {
    name = 'documents';
  }

  const handleSubmit = () => {
    setFormSubmitting(true)
    uploadAttachment(
      {variables: { recordType, recordId, file, name, primary: false }}
    )
  }

  const handleFiles = (files) => {
    setFiles(files)
    // if(attachmentType === 'Expense File') {
      // setValue('expenseFiles', files);
    // }
    setValue(props.name, files)
  }

  return (
    <View>
      <MultiDropzone
        accept={getAccepted()}
        description="Drag and drop files here, or click to choose files."
        handleFiles={handleFiles}
        files={files}
        setFiles={setFiles}
      />
      {/* {attachmentType !== 'Title Log' && attachmentType !== 'Expense File' && */}
      { !['Title Log', 'Expense File', 'Fee File', 'Fee Estimate File'].includes(attachmentType) &&
        <ButtonContainer>
          <ButtonGroup>
            <Button
              label={`Upload ${attachmentType}`}
              onPress={() => handleSubmit()}
            />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )

  function getAccepted() {
    let accepted = ".jpeg, .jpg, .png, .heic";
    if(attachmentType === 'Document' || attachmentType === 'Expense File') {
      accepted = ".pdf, .xls, .xlsx, .doc, .docx";
    }else if(attachmentType === 'Title Log') {
      accepted = ".pdf, .jpeg, .jpg, .png, .heic";
    }

    return accepted;
  }
}
